/* eslint-disable */
export default {
  data() {
    return {
      chatCenterStatus: [
        {
          id: 1, 
          status: 'Espera'
        },
        {
          id: 2, 
          status: 'Por asignar'
        },
        {
          id: 3, 
          status: 'Reasignado'
        },
        {
          id: 4, 
          status: 'Por responder'
        },
        {
          id: 5, 
          status: 'Por resolver'
        },
        {
          id: 6, 
          status: 'Ausente'
        },
        {
          id: 7, 
          status: 'Resuelto'
        },
        {
          id: 8, 
          status: 'Compromiso'
        },
        {
          id: 9, 
          status: 'Conectado'
        },
        {
          id: 10, 
          status: 'Confirmado'
        },
        {
          id: 11, 
          status: 'Entregado'
        },
        {
          id: 12, 
          status: 'Sin compromiso'
        },
        {
          id: 13,
          status: 'Recado',
        },
      ],
    };
  },
  filters: {
    upperCase(value) {
      return value.toUpperCase();
    },
    firstChar(text) {
      if (text) {
        return text.charAt(0);
      }
      return 'D';
    },
    getName(chat) {
      const { customer, user_name } = chat;
      if (customer) {
        const { first_name, last_name, name } = customer;
        if (name) {
          return name;
        } else if(first_name && last_name) {
          return `${first_name} ${last_name}`;
        } else if (first_name || last_name) {
          return first_name || last_name;
        } else if (user_name) {
          return user_name;
        }
        return 'Desconocido';
      }
      if (user_name) {
        return user_name;
      }
      return 'Desconocido';
    },
  },
  methods: {
    getStatusByField(value, toFind, toGet) {
      const index = this.chatCenterStatus.findIndex(item => item[toFind] === value);
      if (index > 0) {
        return this.chatCenterStatus[index][toGet];
      } else {
        return '';
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/chatCenterMixin.js